<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialNumber')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag :disabled="isMmCodeDisabled" v-decorator="['mmCode', validatorRules.mmCode]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialCategory')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag :disabled="isMmCategoryDisabled" v-decorator="['mmCategory']" placeholder="请输入物料类别" dict="efs_md_mm_group,name,code"></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialCommonName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isMmNameDisabled" v-decorator="['mmName']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.specification')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isSpecDisabled" v-decorator="['spec']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.model')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isModelDisabled" v-decorator="['model']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.unitOfMeasurement')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag type="list" :disabled="isUnitDisabled" v-decorator="['unit']" :trigger-change="true" dict="material_unit_type"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.unitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['price']" :placeholder="$t('label.pleaseEnterTheUnitPrice')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.description')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['description']" :placeholder="$t('label.pleaseEnterADescription')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :disabled="isValidFlagDisabled" type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'

  export default {
    name: 'EfsMdGroupPriceListForm',
    components: {
      JFormContainer,
      JDictSelectTag,
      JSearchSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        isMmCodeDisabled: false,
        isMmCategoryDisabled: false,
        isMmNameDisabled: false,
        isSpecDisabled: false,
        isModelDisabled: false,
        isUnitDisabled: false,
        isValidFlagDisabled: false,

        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          mmCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectTheMaterialCommonNameFileNo')},
            ]
          },
        },
        url: {
          add: "/priceList/groupPriceList/efsMdGroupPriceList/add",
          edit: "/priceList/groupPriceList/efsMdGroupPriceList/edit",
          queryById: "/priceList/groupPriceList/efsMdGroupPriceList/queryById",
          queryByMmCode: "/material/efsMdMaterial/queryByCode",
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'mmCode','mmCategory','mmName','spec','model','unit','price','description','validFlag'))
            getAction(this.url.queryByMmCode,{code:this.form.getFieldValue('mmCode')}).then((res)=>{
            if(res.success){
              this.form.setFieldsValue({
                'mmName': res.result.name
              })
            }
          });
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'mmCode','mmCategory','mmName','spec','model','unit','price','description','validFlag'))
      },
    }
  }
</script>